import React, { useEffect, useRef } from "react";
import postEvent, {
  createParkWebRedirectFosEvent,
} from "../commons/LanderEvent";
import { Settings } from "../config";
import { TargetedConfig } from "../commons/ConfigContext";

interface TargetedProps {
  targeted: TargetedConfig;
  queryConfig?: Record<string, any>;
}

export default function TargetedLander({
  targeted,
  queryConfig,
}: TargetedProps) {
  const eventFiredRef = useRef(false);

  useEffect(() => {
    if (eventFiredRef.current) return;
    eventFiredRef.current = true;

    const redirectEvent = createParkWebRedirectFosEvent(queryConfig);
    postEvent(Settings.EVENT_PUBLISH_API, redirectEvent);
  }, [queryConfig]);

  return (
    <iframe
      title="parked-content"
      width="100%"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        border: 0,
      }}
      src={ targeted.fosUrl }
    >
      Sorry your browser does not support inline frames.
    </iframe>
  );
}
